export enum AddEditCaseBreadcrumbSteps {
  productsModelsSelection = 'products-selection',
  productsQuantities = 'quantities',
  details = 'details',
}
